import React from 'react';
import { connect } from 'react-redux';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelContent } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { getDateForServer } from 'apps/auth/components/ga/activity/utils';
import { LAST_MONTH, THIS_MONTH } from 'apps/auth/constants/Constants';
import { resolveArguments } from 'apps/auth/helpers/utils';

const ListScreen = (props) => {
    const date = new Date();
    const month = date.getMonth();
    const currentMonth = props.messages[`month_${month + 1}`].slice(0, 3);
    const lastMonth = props.messages[`month_${month === 0 ? 12 : month}`].slice(0, 3);

    const getDateForView = (period) => {
        const result = ['1'];
        if (period === THIS_MONTH) {
            result.push(String(date.getDate()));
        } else if (period === LAST_MONTH) {
            const today = new Date();
            today.setMonth(today.getMonth());
            today.setDate(0);
            const lastDayLastMonth = today.getDate();
            result.push(String(lastDayLastMonth));
        }
        return result;
    };

    return (
        <>
            <HeaderPanel title={props.accountStatementGet} />
            <Row indent="adaptive-16-24">
                <Panel onClick={() => props.requestToServerStatement(getDateForServer(THIS_MONTH))} isBordered hasBorderRadius isHoverable>
                    <PanelContent>
                        <Text variant="div" indent="4px">
                            {props.statementThisMonth}
                        </Text>
                        <Text size="secondary" color="secondary">
                            {`${resolveArguments(props.statementFromTo, getDateForView(THIS_MONTH))} ${currentMonth}`}
                        </Text>
                    </PanelContent>
                </Panel>
            </Row>
            <Row indent="adaptive-16-24">
                <Panel onClick={() => props.requestToServerStatement(getDateForServer(LAST_MONTH))} isBordered hasBorderRadius isHoverable>
                    <PanelContent>
                        <Text variant="div" indent="4px">
                            {props.statementLastMonth}
                        </Text>
                        <Text size="secondary" color="secondary">
                            {`${resolveArguments(props.statementFromTo, getDateForView(LAST_MONTH))} ${lastMonth}`}
                        </Text>
                    </PanelContent>
                </Panel>
            </Row>
            <Row indent="adaptive-16-24">
                <Panel onClick={props.setShowPeriod} isBordered hasBorderRadius isHoverable>
                    <Text>{props.selectPeriod}</Text>
                </Panel>
            </Row>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        accountStatementGet: state.messages.pageMessages.accountStatementGet,
        statementThisMonth: state.messages.pageMessages.statementThisMonth,
        statementLastMonth: state.messages.pageMessages.statementLastMonth,
        selectPeriod: state.messages.pageMessages.selectPeriod,
        statementFromTo: state.messages.pageMessages.statementFromTo,
        messages: state.messages.pageMessages,
    };
};
export default connect(mapStateToProps)(ListScreen);
